import { Box, Grid, IconButton, Stack, Typography } from '@mui/material';
import { styled } from '@mui/system';

export const HeaderWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  z-index: 999;
`;

export const StyledStack = styled(Stack)`
  overflow: hidden;

  button {
    justify-content: flex-start;
  }
`;

export const StyledIconButton = styled(IconButton)`
  padding-top: 18px;
`;

export const StyledGrid = styled(Grid)`
  overflow: hidden;
`;

export const StyledBox = styled(Box)`
  display: flex;
`;

export const StyledWrapper = styled('span')`
  display: flex;
  align-items: baseline;

  & h1 {
    margin-right: 5px;
  }

  & div {
    overflow: hidden;
  }
`;

export const HeaderTitle = styled(Typography)`
  flex: 1;
  padding-right: 16px;
`;

export const ActionBarBox = styled(Box)`
  white-space: nowrap;
`;
